import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PaymentGateWay from "./PaymentGateWay2";
import { setPageMeta } from "../../utils/setPageMeta";

const CSS_TEXT = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

.mm-pricing *,.mm-pricing *::before,.mm-pricing *::after{box-sizing:border-box;margin:0;padding:0;}
.mm-pricing{
  --p:#6B21B6;--pd:#3D1068;--pp:#1E0840;--pm:#5B1A9A;
  --pl:#EDE0FA;--pw:#F7F3FE;--am:#F59E0B;--aml:#FEF3C7;
  --w:#fff;--th:#0F0A1E;--tm:#6B6892;--br:#E8E3F5;
  --gr:#065F46;--gl:#D1F0E4;--rd:#B91C1C;
  font-family:'Inter',sans-serif;color:var(--th);line-height:1.5;font-size:15px;
}

/* HERO */
.mm-hero{background:linear-gradient(148deg,var(--pp) 0%,#3D1270 35%,var(--p) 70%,#8B35D6 100%);padding:80px 56px 120px;text-align:center;position:relative;overflow:hidden;}
.mm-hero-grid{position:absolute;inset:0;background-image:linear-gradient(rgba(255,255,255,0.04) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.04) 1px,transparent 1px);background-size:40px 40px;pointer-events:none;}
.mm-hero-glow{position:absolute;top:-100px;left:50%;transform:translateX(-50%);width:600px;height:600px;background:radial-gradient(ellipse,rgba(245,158,11,0.18) 0%,transparent 65%);pointer-events:none;}
.mm-hero-content{position:relative;z-index:1;}
.mm-hero-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(245,158,11,0.15);border:1px solid rgba(245,158,11,0.35);color:var(--am);font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;padding:7px 18px;border-radius:99px;margin-bottom:24px;}
.mm-hero-badge span{width:6px;height:6px;border-radius:50%;background:var(--am);display:inline-block;animation:mm-pulse 2s infinite;}
@keyframes mm-pulse{0%,100%{opacity:1;transform:scale(1);}50%{opacity:.5;transform:scale(.8);}}
.mm-hero h1{color:#fff;font-size:56px;font-weight:900;line-height:1.08;letter-spacing:-2px;margin-bottom:18px;text-shadow:none;}
.mm-hero h1 .mm-hl{color:var(--am);}
.mm-hero-sub{color:rgba(255,255,255,0.68);font-size:18px;max-width:520px;margin:0 auto 36px;line-height:1.6;font-weight:400;}
.mm-hero-trust{display:flex;justify-content:center;align-items:center;gap:24px;margin-bottom:44px;flex-wrap:wrap;}
.mm-ht-item{display:flex;align-items:center;gap:7px;color:rgba(255,255,255,0.75);font-size:13px;font-weight:500;}
.mm-ht-item::before{content:'\\2713';color:var(--am);font-weight:700;font-size:13px;}
.mm-hero-stats{display:flex;justify-content:center;gap:0;border:1px solid rgba(255,255,255,0.12);border-radius:16px;overflow:hidden;background:rgba(255,255,255,0.06);backdrop-filter:blur(8px);width:fit-content;margin:0 auto;}
.mm-hs-item{padding:18px 32px;text-align:center;border-right:1px solid rgba(255,255,255,0.1);}
.mm-hs-item:last-child{border-right:none;}
.mm-hs-num{font-size:22px;font-weight:800;color:var(--am);line-height:1;}
.mm-hs-lbl{font-size:11px;color:rgba(255,255,255,0.55);margin-top:4px;font-weight:500;}

/* PLANS SECTION */
.mm-plans{background:var(--pw);padding:48px 56px 80px;}

/* FREE BAR */
.mm-free-bar{max-width:1160px;margin:0 auto 28px;background:var(--w);border-radius:14px;border:1.5px solid var(--br);padding:18px 28px;display:flex;align-items:center;justify-content:space-between;box-shadow:0 2px 12px rgba(107,33,182,0.05);flex-wrap:wrap;gap:16px;}
.mm-fb-l{display:flex;align-items:center;gap:14px;}
.mm-fb-icon{width:42px;height:42px;border-radius:11px;background:var(--pw);display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0;}
.mm-fb-name{font-size:15px;font-weight:700;color:var(--th);}
.mm-fb-desc{font-size:12px;color:var(--tm);margin-top:3px;}
.mm-fb-r{display:flex;align-items:center;gap:16px;}
.mm-fb-limit{font-size:12px;color:var(--tm);border-left:1px solid var(--br);padding-left:16px;}
.mm-fb-cta{background:none;border:1.5px solid var(--br);color:var(--th);font-size:12px;font-weight:600;padding:8px 20px;border-radius:8px;cursor:pointer;font-family:inherit;transition:all .2s;}
.mm-fb-cta:hover{border-color:var(--p);color:var(--p);}

/* SECTION DIVIDER */
.mm-sdiv{max-width:1160px;margin:0 auto 20px;display:flex;align-items:center;gap:14px;}
.mm-sd-line{flex:1;height:1px;background:var(--br);}
.mm-sd-label{font-size:11px;font-weight:700;color:var(--tm);text-transform:uppercase;letter-spacing:1.5px;white-space:nowrap;padding:0 4px;}

/* BASIC PLAN */
.mm-basic-wrap{max-width:1160px;margin:0 auto 28px;}
.mm-basic-card{background:var(--w);border-radius:18px;border:2px solid var(--am);display:grid;grid-template-columns:1.2fr 1.4fr 1fr;overflow:hidden;box-shadow:0 4px 24px rgba(245,158,11,0.12);}
.mm-basic-left{padding:28px 28px 24px;background:linear-gradient(145deg,#FFF8E8,#FFFBF0);border-right:1px solid #F5E5B8;}
.mm-bl-tag{display:inline-flex;align-items:center;gap:6px;background:var(--am);color:#fff;font-size:10px;font-weight:700;padding:4px 12px;border-radius:99px;margin-bottom:14px;letter-spacing:0.5px;}
.mm-bl-name{font-size:22px;font-weight:800;color:var(--th);margin-bottom:4px;}
.mm-bl-sub{font-size:13px;color:#92400E;margin-bottom:16px;font-weight:500;}
.mm-bl-price{font-size:44px;font-weight:900;color:var(--am);line-height:1;}
.mm-bl-price sub{font-size:16px;font-weight:500;color:#92400E;}
.mm-bl-note{font-size:12px;color:#92400E;margin-top:8px;margin-bottom:20px;}
.mm-bl-guarantee{font-size:11px;color:#92400E;text-align:center;margin-top:10px;display:flex;align-items:center;justify-content:center;gap:5px;}
.mm-basic-mid{padding:28px;border-right:1px solid #F5E5B8;}
.mm-basic-right{padding:28px;background:#FFFCF5;}
.mm-bsec-title{font-size:11px;font-weight:700;color:var(--tm);text-transform:uppercase;letter-spacing:1px;margin-bottom:14px;}
.mm-fi{display:flex;align-items:flex-start;gap:9px;font-size:13px;color:var(--th);padding:5px 0;line-height:1.4;}
.mm-fic{width:18px;height:18px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:10px;flex-shrink:0;margin-top:1px;}
.mm-fic-g{background:var(--gl);color:var(--gr);}
.mm-fic-x{background:#F1EFF8;color:var(--tm);}
.mm-fic-a{background:var(--aml);color:#92400E;}
.mm-fi.mm-dim{color:var(--tm);}
.mm-topic-card{background:#FFF8E8;border-radius:10px;padding:12px 14px;border:1px solid #F5E5B8;}
.mm-tc-row{display:flex;align-items:center;gap:8px;font-size:12px;color:var(--th);padding:4px 0;}
.mm-tc-dot{width:5px;height:5px;border-radius:50%;background:var(--am);flex-shrink:0;}
.mm-tc-note{font-size:11px;color:var(--tm);font-style:italic;margin-top:8px;padding-top:8px;border-top:1px solid #F5E5B8;}

/* SILVER */
.mm-silver-wrap{max-width:1160px;margin:0 auto 28px;}
.mm-silver-card{background:var(--w);border-radius:18px;border:2.5px solid var(--p);display:grid;grid-template-columns:1.2fr 1fr 1fr;overflow:hidden;box-shadow:0 8px 32px rgba(107,33,182,0.14);}
.mm-silver-top-bar{background:var(--p);padding:10px 28px;display:flex;align-items:center;justify-content:space-between;grid-column:1/-1;flex-wrap:wrap;gap:8px;}
.mm-stb-left{color:#fff;font-size:13px;font-weight:700;display:flex;align-items:center;gap:8px;}
.mm-stb-right{color:rgba(255,255,255,0.8);font-size:12px;}
.mm-silver-left{padding:28px;border-right:1px solid var(--br);background:linear-gradient(145deg,#F8F4FF,#F3EFFE);}
.mm-sl-badge{display:inline-block;background:var(--pl);color:var(--p);font-size:10px;font-weight:700;padding:4px 12px;border-radius:99px;margin-bottom:14px;}
.mm-sl-name{font-size:22px;font-weight:800;color:var(--th);margin-bottom:4px;}
.mm-sl-period{font-size:12px;color:var(--tm);margin-bottom:16px;font-weight:500;}
.mm-sl-old{font-size:13px;color:var(--tm);text-decoration:line-through;margin-bottom:3px;}
.mm-sl-price{font-size:44px;font-weight:900;color:var(--p);line-height:1;}
.mm-sl-price sub{font-size:16px;font-weight:500;color:var(--tm);}
.mm-sl-save{display:inline-block;background:var(--gl);color:var(--gr);font-size:11px;font-weight:700;padding:4px 12px;border-radius:99px;margin:10px 0 20px;}
.mm-sl-cta{background:var(--p);color:#fff;border:none;border-radius:11px;padding:13px;font-size:14px;font-weight:700;cursor:pointer;font-family:inherit;width:100%;transition:all .2s;}
.mm-sl-cta:hover{background:var(--pd);transform:translateY(-1px);}
.mm-sl-sub-note{font-size:11px;color:var(--tm);text-align:center;margin-top:8px;}
.mm-silver-mid,.mm-silver-right{padding:28px;}

/* VALIDITY GRID */
.mm-val-grid{max-width:1160px;margin:0 auto;display:grid;grid-template-columns:1fr 1fr 1fr;gap:16px;}
.mm-val-card{background:var(--w);border-radius:18px;border:1.5px solid var(--br);overflow:hidden;transition:all .25s;}
.mm-val-card:hover{transform:translateY(-4px);box-shadow:0 12px 36px rgba(107,33,182,0.1);border-color:var(--p);}
.mm-val-card.mm-pop{border:2.5px solid var(--p);box-shadow:0 8px 28px rgba(107,33,182,0.14);}
.mm-val-pop-bar{background:var(--p);color:#fff;font-size:11px;font-weight:700;text-align:center;padding:9px;letter-spacing:0.5px;}
.mm-vc-head{padding:24px 24px 18px;}
.mm-vc-vtag{display:inline-block;background:var(--pw);color:var(--p);font-size:10px;font-weight:700;padding:4px 12px;border-radius:99px;margin-bottom:14px;border:1px solid var(--pl);}
.mm-vc-name{font-size:20px;font-weight:800;color:var(--th);margin-bottom:3px;}
.mm-vc-period{font-size:12px;color:var(--tm);font-weight:500;margin-bottom:14px;}
.mm-vc-old{font-size:12px;color:var(--tm);text-decoration:line-through;margin-bottom:2px;}
.mm-vc-price{font-size:36px;font-weight:900;color:var(--p);line-height:1;}
.mm-vc-price sub{font-size:14px;font-weight:500;color:var(--tm);}
.mm-vc-eff{font-size:11px;color:var(--gr);font-weight:600;background:var(--gl);padding:3px 10px;border-radius:99px;display:inline-block;margin:8px 0;}
.mm-vc-save{font-size:11px;color:var(--tm);margin-bottom:4px;}
.mm-vc-divider{height:1px;background:var(--br);margin:0 24px;}
.mm-vc-body{padding:18px 24px 22px;}
.mm-vc-same{background:var(--pw);border-radius:9px;padding:10px 12px;font-size:12px;color:var(--p);font-weight:600;margin-bottom:12px;border:1px solid var(--pl);text-align:center;}
.mm-vc-cta{display:block;padding:12px;border-radius:11px;font-size:13px;font-weight:700;text-align:center;cursor:pointer;font-family:inherit;border:none;width:100%;transition:all .2s;text-decoration:none;}
.mm-cta-p{background:var(--p);color:#fff;}
.mm-cta-p:hover{background:var(--pd);}
.mm-cta-o{background:var(--w);color:var(--p);border:2px solid var(--p)!important;}
.mm-cta-o:hover{background:var(--pl);}

/* COMPARE TABLE */
.mm-compare{padding:70px 56px 80px;background:var(--w);}
.mm-sec-head{text-align:center;margin-bottom:40px;}
.mm-sec-head h2{font-size:36px;font-weight:900;color:var(--th);letter-spacing:-0.5px;margin-bottom:8px;}
.mm-sec-head p{font-size:16px;color:var(--tm);}
.mm-ct-outer{max-width:1000px;margin:0 auto;border-radius:18px;overflow:hidden;border:1.5px solid var(--br);box-shadow:0 4px 24px rgba(107,33,182,0.07);}
.mm-ct-head{display:grid;grid-template-columns:2.2fr repeat(5,1fr);background:var(--pp);padding:16px 24px;}
.mm-ct-hc{text-align:center;color:rgba(255,255,255,0.6);font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.8px;line-height:1.4;}
.mm-ct-hc:first-child{text-align:left;}
.mm-ct-hc.mm-am-col{color:var(--am);font-size:12px;}
.mm-ct-row{display:grid;grid-template-columns:2.2fr repeat(5,1fr);padding:12px 24px;border-bottom:1px solid var(--br);align-items:center;}
.mm-ct-row:last-child{border-bottom:none;}
.mm-ct-row.mm-alt{background:var(--pw);}
.mm-ct-fn{font-size:13px;font-weight:500;color:var(--th);}
.mm-ct-fs{font-size:11px;color:var(--tm);margin-top:2px;}
.mm-ct-v{text-align:center;font-size:12px;font-weight:500;color:var(--th);}
.mm-ctc{color:var(--gr);font-size:16px;font-weight:700;}
.mm-ctx{color:#C4B8F8;font-size:16px;}
.mm-ct-hl{color:var(--p);font-weight:700;}

/* SOCIAL PROOF */
.mm-proof{background:linear-gradient(148deg,var(--pp),var(--p));padding:70px 56px;}
.mm-proof .mm-sec-head h2{color:#fff;}
.mm-proof .mm-sec-head p{color:rgba(255,255,255,0.65);}
.mm-proof-stats{display:flex;justify-content:center;gap:0;margin-bottom:44px;border:1px solid rgba(255,255,255,0.12);border-radius:16px;overflow:hidden;background:rgba(255,255,255,0.06);width:fit-content;margin:0 auto 44px;}
.mm-ps-item{padding:20px 36px;text-align:center;border-right:1px solid rgba(255,255,255,0.1);}
.mm-ps-item:last-child{border-right:none;}
.mm-ps-num{font-size:26px;font-weight:900;color:var(--am);}
.mm-ps-lbl{font-size:11px;color:rgba(255,255,255,0.55);margin-top:4px;}
.mm-review-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;max-width:1000px;margin:0 auto;}
.mm-rev-card{background:rgba(255,255,255,0.08);backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,0.12);border-radius:14px;padding:20px;}
.mm-rev-stars{color:var(--am);font-size:14px;margin-bottom:10px;}
.mm-rev-text{font-size:13px;color:rgba(255,255,255,0.85);line-height:1.6;margin-bottom:12px;}
.mm-rev-name{font-size:12px;color:rgba(255,255,255,0.5);font-weight:600;}

/* FAQ */
.mm-faq{padding:70px 56px 80px;background:var(--pw);}
.mm-faq-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;max-width:880px;margin:0 auto;}
.mm-faq-card{background:var(--w);border-radius:13px;padding:20px 22px;border:1px solid var(--br);cursor:pointer;transition:border-color .2s;}
.mm-faq-card:hover{border-color:var(--p);}
.mm-fq{font-size:13px;font-weight:700;color:var(--th);margin-bottom:8px;}
.mm-fa{font-size:12px;color:var(--tm);line-height:1.7;}

/* BOTTOM CTA */
.mm-bottom-cta{padding:70px 56px;background:var(--w);text-align:center;border-top:1px solid var(--br);}
.mm-bottom-cta h2{font-size:36px;font-weight:900;color:var(--th);letter-spacing:-0.5px;margin-bottom:10px;}
.mm-bottom-cta p{color:var(--tm);font-size:16px;margin-bottom:32px;max-width:460px;margin-left:auto;margin-right:auto;}
.mm-bc-btns{display:flex;gap:12px;justify-content:center;}
.mm-bc-btn{padding:15px 36px;border-radius:12px;font-size:15px;font-weight:700;cursor:pointer;font-family:inherit;border:none;text-decoration:none;transition:all .2s;display:inline-block;}
.mm-bc-p{background:var(--p);color:#fff;}
.mm-bc-p:hover{background:var(--pd);transform:translateY(-1px);}
.mm-bc-g{background:var(--w);color:var(--p);border:2px solid var(--p)!important;}
.mm-bc-g:hover{background:var(--pl);}
.mm-bc-trust{display:flex;justify-content:center;gap:24px;margin-top:24px;flex-wrap:wrap;}
.mm-bct-item{display:flex;align-items:center;gap:6px;font-size:12px;color:var(--tm);}
.mm-bct-item::before{content:'\\2713';color:var(--gr);font-weight:700;}

/* COUPON */
.mm-coupon-wrap{margin-top:14px;}
.mm-coupon-input{width:100%;padding:10px 14px;border:1.5px solid var(--br);border-radius:9px;font-size:13px;font-family:inherit;outline:none;transition:border-color .2s;}
.mm-coupon-input:focus{border-color:var(--p);}
.mm-coupon-input::placeholder{color:var(--tm);}

/* RESPONSIVE */
@media(max-width:960px){
  .mm-basic-card{grid-template-columns:1fr;}
  .mm-silver-card{grid-template-columns:1fr;}
  .mm-val-grid{grid-template-columns:1fr;}
  .mm-ct-head,.mm-ct-row{grid-template-columns:2fr repeat(5,1fr);font-size:10px;}
  .mm-review-grid{grid-template-columns:1fr;}
  .mm-faq-grid{grid-template-columns:1fr;}
  .mm-hero h1{font-size:36px;}
  .mm-hero{padding:60px 24px 80px;}
  .mm-plans{padding:32px 20px 60px;}
  .mm-compare{padding:50px 20px 60px;}
  .mm-proof{padding:50px 20px;}
  .mm-faq{padding:50px 20px 60px;}
  .mm-bottom-cta{padding:50px 20px;}
  .mm-free-bar{flex-direction:column;align-items:flex-start;}
}
`;

export default function ResponsivePricing() {
  const [coupon, setCoupon] = useState("");

  useEffect(() => {
    setPageMeta(
      "JEE & NEET Mentorship Plans: Starting ₹249 | MentoMEET",
      "Affordable JEE & NEET mentorship plans. Try 1 session for ₹249 or get full mentorship from ₹1,299/month. IIT & AIIMS toppers. 7-day money-back guarantee."
    );
  }, []);

  return (
    <div className="mm-pricing">
      <style>{CSS_TEXT}</style>

      {/* HERO */}
      <div className="mm-hero">
        <div className="mm-hero-grid"></div>
        <div className="mm-hero-glow"></div>
        <div className="mm-hero-content">
          <div className="mm-hero-badge"><span></span> JEE &middot; NEET Mentorship</div>
          <h1>Invest in your rank.<br /><span className="mm-hl">Choose your edge.</span></h1>
          <p className="mm-hero-sub">Personalised 1-on-1 mentoring from IIT, AIIMS &amp; NIT toppers. Start free &mdash; upgrade only when you're ready.</p>
          <div className="mm-hero-trust">
            <div className="mm-ht-item">No credit card to start</div>
            <div className="mm-ht-item">Cancel anytime</div>
            <div className="mm-ht-item">7-day money-back guarantee</div>
            <div className="mm-ht-item">Real IIT &amp; AIIMS toppers</div>
          </div>
          <div className="mm-hero-stats">
            <div className="mm-hs-item"><div className="mm-hs-num">500+</div><div className="mm-hs-lbl">Verified mentors</div></div>
            <div className="mm-hs-item"><div className="mm-hs-num">IIT &middot; AIIMS</div><div className="mm-hs-lbl">NIT &middot; Top Medical</div></div>
            <div className="mm-hs-item"><div className="mm-hs-num">4.9&#9733;</div><div className="mm-hs-lbl">Avg mentor rating</div></div>
            <div className="mm-hs-item"><div className="mm-hs-num">&#8377;249</div><div className="mm-hs-lbl">Try &mdash; no commitment</div></div>
          </div>
        </div>
      </div>

      {/* PLANS */}
      <div className="mm-plans">

        {/* FREE BAR */}
        <div className="mm-free-bar">
          <div className="mm-fb-l">
            <div className="mm-fb-icon">&#127891;</div>
            <div>
              <div className="mm-fb-name">Free &mdash; always free</div>
              <div className="mm-fb-desc">Message 1 mentor &middot; Browse all mentor profiles &middot; No sessions</div>
            </div>
          </div>
          <div className="mm-fb-r">
            <div className="mm-fb-limit">No sessions included &middot; Chat only</div>
            <Link to="/register" className="mm-fb-cta" style={{ textDecoration: "none" }}>Start free &rarr;</Link>
          </div>
        </div>

        {/* BASIC */}
        <div className="mm-sdiv"><div className="mm-sd-line"></div><div className="mm-sd-label">Try first &mdash; no commitment</div><div className="mm-sd-line"></div></div>
        <div className="mm-basic-wrap">
          <div className="mm-basic-card">
            <div className="mm-basic-left">
              <div className="mm-bl-tag">&#9889; Try it once</div>
              <div className="mm-bl-name">Basic</div>
              <div className="mm-bl-sub">One-time session &middot; No subscription</div>
              <div className="mm-bl-price">&#8377;249 <sub>one time</sub></div>
              <div className="mm-bl-note">Pay once. No auto-renewal. Ever.</div>
              <div className="mm-coupon-wrap">
                <input
                  type="text"
                  className="mm-coupon-input"
                  placeholder="Enter coupon code"
                  value={coupon}
                  onChange={(e) => setCoupon(e.target.value)}
                />
              </div>
              <div style={{ marginTop: "12px" }}>
                <PaymentGateWay coupon={coupon} amount={24900} PlanId="601308b9af3c7e63a7b658fc" />
              </div>
              <div className="mm-bl-guarantee">&#128274; 7-day money-back guarantee</div>
            </div>
            <div className="mm-basic-mid">
              <div className="mm-bsec-title">What's included</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-a">&#10003;</div> 1 session with a verified IIT/AIIMS mentor</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-a">&#10003;</div> 45&ndash;60 min of focused discussion</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-a">&#10003;</div> Surface-level guidance on your chosen topic</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-a">&#10003;</div> Pre-session chat to explain your doubt</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-a">&#10003;</div> Session notes shared after the call</div>
              <div className="mm-fi mm-dim" style={{ marginTop: "8px" }}><div className="mm-fic mm-fic-x">&#10005;</div> No ongoing mentor support</div>
              <div className="mm-fi mm-dim"><div className="mm-fic mm-fic-x">&#10005;</div> No daily check-in</div>
              <div className="mm-fi mm-dim"><div className="mm-fic mm-fic-x">&#10005;</div> No mock test tracking</div>
            </div>
            <div className="mm-basic-right">
              <div className="mm-bsec-title">Choose your topic</div>
              <div className="mm-topic-card">
                <div className="mm-tc-row"><div className="mm-tc-dot"></div> How to analyse your mock test</div>
                <div className="mm-tc-row"><div className="mm-tc-dot"></div> Book &amp; resource selection strategy</div>
                <div className="mm-tc-row"><div className="mm-tc-dot"></div> Revision planning strategy</div>
                <div className="mm-tc-row"><div className="mm-tc-dot"></div> Subject-wise study strategy</div>
                <div className="mm-tc-row"><div className="mm-tc-dot"></div> Marks improvement roadmap</div>
                <div className="mm-tc-note">One topic per session &middot; Surface-level guidance only</div>
              </div>
              <div style={{ marginTop: "16px", background: "#FEF3C7", borderRadius: "9px", padding: "12px 14px" }}>
                <div style={{ fontSize: "12px", fontWeight: 700, color: "#92400E", marginBottom: "3px" }}>Perfect if you want to...</div>
                <div style={{ fontSize: "12px", color: "#92400E", lineHeight: 1.6 }}>Get unstuck fast, understand your weak points, or see how MentoMEET works &mdash; before committing to a plan.</div>
              </div>
            </div>
          </div>
        </div>

        {/* SILVER */}
        <div className="mm-sdiv"><div className="mm-sd-line"></div><div className="mm-sd-label">Full mentorship &mdash; everything included</div><div className="mm-sd-line"></div></div>
        <div className="mm-silver-wrap">
          <div className="mm-silver-card">
            <div className="mm-silver-top-bar">
              <div className="mm-stb-left">&#129352; Silver &mdash; Full 1-month mentorship &middot; Everything your preparation needs</div>
              <div className="mm-stb-right">The base plan &middot; Gold / Platinum / Diamond = Same features, longer validity</div>
            </div>
            <div className="mm-silver-left">
              <div className="mm-sl-badge">Most complete plan</div>
              <div className="mm-sl-name">Silver</div>
              <div className="mm-sl-period">1 month mentorship</div>
              <div className="mm-sl-old">&#8377;1,999 / month</div>
              <div className="mm-sl-price">&#8377;1,299 <sub>/month</sub></div>
              <div className="mm-sl-save">You save &#8377;700</div>
              <div className="mm-coupon-wrap">
                <input
                  type="text"
                  className="mm-coupon-input"
                  placeholder="Enter coupon code"
                  value={coupon}
                  onChange={(e) => setCoupon(e.target.value)}
                />
              </div>
              <div style={{ marginTop: "12px" }}>
                <PaymentGateWay coupon={coupon} amount={129900} PlanId="601b0d137de4551cf96bdb1f" />
              </div>
              <div className="mm-sl-sub-note">Cancel anytime &middot; 7-day money-back</div>
              <div style={{ marginTop: "16px", background: "#EDE0FA", borderRadius: "9px", padding: "12px 14px", fontSize: "12px", color: "#6B21B6", lineHeight: 1.6 }}>
                <strong>Want more than 1 month?</strong> Gold, Platinum and Diamond are the same plan &mdash; just longer. The longer you go, the less you pay per month.
              </div>
            </div>
            <div className="mm-silver-mid">
              <div className="mm-bsec-title">Sessions &amp; daily support</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> <strong>2 sessions every week</strong> &mdash; 8 sessions/month</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Unlimited chat with your allotted mentor</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> <strong>Daily check-in &amp; check-out</strong> with mentor</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> WhatsApp session reminders</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Session notes &amp; action plan after each call</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Dedicated single mentor assigned to you</div>
            </div>
            <div className="mm-silver-right">
              <div className="mm-bsec-title">Study tools &amp; tracking</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Deep mock test analysis &mdash; every test reviewed</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> <strong>Error book</strong> maintained by your mentor</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Study material recommendation</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Subject-wise strategy &amp; scheduling</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Revision planning tailored to your syllabus</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Weekly marks improvement tracking</div>
            </div>
          </div>
        </div>

        {/* VALIDITY PLANS */}
        <div className="mm-sdiv"><div className="mm-sd-line"></div><div className="mm-sd-label">Longer validity = lower monthly cost</div><div className="mm-sd-line"></div></div>
        <div className="mm-val-grid">

          {/* GOLD */}
          <div className="mm-val-card">
            <div className="mm-vc-head">
              <div className="mm-vc-vtag">3 months validity</div>
              <div className="mm-vc-name">Gold &#128081;</div>
              <div className="mm-vc-period">All Silver features &middot; 3&times; the duration</div>
              <div className="mm-vc-old">&#8377;5,499</div>
              <div className="mm-vc-price">&#8377;3,299 <sub>/3 months</sub></div>
              <div className="mm-vc-eff">= &#8377;1,099/month</div>
              <div className="mm-vc-save">You save &#8377;2,200 vs monthly</div>
            </div>
            <div className="mm-vc-divider"></div>
            <div className="mm-vc-body">
              <div className="mm-vc-same">&#10003; Everything in Silver &mdash; 3 months</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> 2 sessions/week &times; 12 weeks</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Same mentor continuity for 3 months</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Long-term mock test progress tracking</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Mid-plan strategy review session</div>
              <div className="mm-coupon-wrap">
                <input type="text" className="mm-coupon-input" placeholder="Enter coupon code" value={coupon} onChange={(e) => setCoupon(e.target.value)} />
              </div>
              <div style={{ marginTop: "12px" }}>
                <PaymentGateWay coupon={coupon} amount={329900} PlanId="601308b9af3c7e63a7b658f9" />
              </div>
            </div>
          </div>

          {/* PLATINUM */}
          <div className="mm-val-card mm-pop">
            <div className="mm-val-pop-bar">&#11088; Most popular &middot; Best for serious prep</div>
            <div className="mm-vc-head">
              <div className="mm-vc-vtag">6 months validity</div>
              <div className="mm-vc-name">Platinum &#128142;</div>
              <div className="mm-vc-period">All Silver features &middot; 6&times; the duration</div>
              <div className="mm-vc-old">&#8377;7,999</div>
              <div className="mm-vc-price">&#8377;5,299 <sub>/6 months</sub></div>
              <div className="mm-vc-eff">= &#8377;883/month</div>
              <div className="mm-vc-save">You save &#8377;2,700 vs monthly</div>
            </div>
            <div className="mm-vc-divider"></div>
            <div className="mm-vc-body">
              <div className="mm-vc-same">&#10003; Everything in Silver &mdash; 6 months</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> 2 sessions/week &times; 24 weeks</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Mentor continuity + backup mentor option</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Covers full pre-exam preparation cycle</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Monthly performance review reports</div>
              <div className="mm-coupon-wrap">
                <input type="text" className="mm-coupon-input" placeholder="Enter coupon code" value={coupon} onChange={(e) => setCoupon(e.target.value)} />
              </div>
              <div style={{ marginTop: "12px" }}>
                <PaymentGateWay coupon={coupon} amount={529900} PlanId="601308b9af3c7e63a7b658f6" />
              </div>
            </div>
          </div>

          {/* DIAMOND */}
          <div className="mm-val-card">
            <div className="mm-vc-head">
              <div className="mm-vc-vtag">12 months validity</div>
              <div className="mm-vc-name">Diamond &#127942;</div>
              <div className="mm-vc-period">All Silver features &middot; Full year</div>
              <div className="mm-vc-old">&#8377;9,999</div>
              <div className="mm-vc-price">&#8377;8,999 <sub>/year</sub></div>
              <div className="mm-vc-eff">= &#8377;750/month &middot; Lowest cost</div>
              <div className="mm-vc-save">You save &#8377;1,000 + lowest per month</div>
            </div>
            <div className="mm-vc-divider"></div>
            <div className="mm-vc-body">
              <div className="mm-vc-same">&#10003; Everything in Silver &mdash; 12 months</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> 2 sessions/week &times; 48 weeks</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Priority mentor matching</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Dedicated success manager</div>
              <div className="mm-fi"><div className="mm-fic mm-fic-g">&#10003;</div> Quarterly progress reports</div>
              <div className="mm-coupon-wrap">
                <input type="text" className="mm-coupon-input" placeholder="Enter coupon code" value={coupon} onChange={(e) => setCoupon(e.target.value)} />
              </div>
              <div style={{ marginTop: "12px" }}>
                <PaymentGateWay coupon={coupon} amount={899900} PlanId="601308b9af3c7e63a7b658f7" />
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* COMPARE TABLE */}
      <div className="mm-compare">
        <div className="mm-sec-head">
          <h2>Compare every plan</h2>
          <p>No surprises. See exactly what you get before you pay.</p>
        </div>
        <div className="mm-ct-outer">
          <div className="mm-ct-head">
            <div className="mm-ct-hc" style={{ textAlign: "left" }}>Feature</div>
            <div className="mm-ct-hc">Free</div>
            <div className="mm-ct-hc">Basic<br /><span style={{ fontSize: "9px", opacity: 0.6 }}>&#8377;249 once</span></div>
            <div className="mm-ct-hc mm-am-col">Silver &#129352;<br /><span style={{ fontSize: "9px", color: "rgba(255,255,255,.5)" }}>&#8377;1,299/mo</span></div>
            <div className="mm-ct-hc">Gold / Platinum<br /><span style={{ fontSize: "9px", opacity: 0.6 }}>Longer validity</span></div>
            <div className="mm-ct-hc">Diamond &#127942;<br /><span style={{ fontSize: "9px", opacity: 0.6 }}>&#8377;8,999/yr</span></div>
          </div>
          <div className="mm-ct-row mm-alt">
            <div><div className="mm-ct-fn">Chat with mentor</div><div className="mm-ct-fs">Messaging access</div></div>
            <div className="mm-ct-v">1 mentor only</div>
            <div className="mm-ct-v">Pre-session</div>
            <div className="mm-ct-v mm-ct-hl">Unlimited</div>
            <div className="mm-ct-v mm-ct-hl">Unlimited</div>
            <div className="mm-ct-v mm-ct-hl">Unlimited</div>
          </div>
          <div className="mm-ct-row">
            <div><div className="mm-ct-fn">Sessions per week</div><div className="mm-ct-fs">Live 1-on-1 calls</div></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v">1 session only</div>
            <div className="mm-ct-v mm-ct-hl">2 / week</div>
            <div className="mm-ct-v mm-ct-hl">2 / week</div>
            <div className="mm-ct-v mm-ct-hl">2 / week</div>
          </div>
          <div className="mm-ct-row mm-alt">
            <div><div className="mm-ct-fn">Daily check-in &amp; check-out</div><div className="mm-ct-fs">Accountability every day</div></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v"><span className="mm-ctc">&#10003;</span></div>
            <div className="mm-ct-v"><span className="mm-ctc">&#10003;</span></div>
            <div className="mm-ct-v"><span className="mm-ctc">&#10003;</span></div>
          </div>
          <div className="mm-ct-row">
            <div><div className="mm-ct-fn">Mock test analysis</div><div className="mm-ct-fs">Detailed error review</div></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v">Surface level</div>
            <div className="mm-ct-v mm-ct-hl">Deep analysis</div>
            <div className="mm-ct-v mm-ct-hl">Deep analysis</div>
            <div className="mm-ct-v mm-ct-hl">Deep analysis</div>
          </div>
          <div className="mm-ct-row mm-alt">
            <div><div className="mm-ct-fn">Error book by mentor</div><div className="mm-ct-fs">Your personal mistake tracker</div></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v"><span className="mm-ctc">&#10003;</span></div>
            <div className="mm-ct-v"><span className="mm-ctc">&#10003;</span></div>
            <div className="mm-ct-v"><span className="mm-ctc">&#10003;</span></div>
          </div>
          <div className="mm-ct-row">
            <div><div className="mm-ct-fn">Study material recommendation</div></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v"><span className="mm-ctc">&#10003;</span></div>
            <div className="mm-ct-v"><span className="mm-ctc">&#10003;</span></div>
            <div className="mm-ct-v"><span className="mm-ctc">&#10003;</span></div>
          </div>
          <div className="mm-ct-row mm-alt">
            <div><div className="mm-ct-fn">WhatsApp reminders</div></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v"><span className="mm-ctc">&#10003;</span></div>
            <div className="mm-ct-v"><span className="mm-ctc">&#10003;</span></div>
            <div className="mm-ct-v"><span className="mm-ctc">&#10003;</span></div>
          </div>
          <div className="mm-ct-row">
            <div><div className="mm-ct-fn">Priority mentor matching</div></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v"><span className="mm-ctx">&#10005;</span></div>
            <div className="mm-ct-v"><span className="mm-ctc">&#10003;</span></div>
          </div>
          <div className="mm-ct-row mm-alt">
            <div><div className="mm-ct-fn">Validity</div></div>
            <div className="mm-ct-v">Forever</div>
            <div className="mm-ct-v">1 session</div>
            <div className="mm-ct-v mm-ct-hl">1 month</div>
            <div className="mm-ct-v mm-ct-hl">3 or 6 mo</div>
            <div className="mm-ct-v mm-ct-hl">12 months</div>
          </div>
        </div>
      </div>

      {/* SOCIAL PROOF */}
      <div className="mm-proof">
        <div className="mm-sec-head">
          <h2>Students who chose MentoMEET</h2>
          <p>Real results from real aspirants</p>
        </div>
        <div className="mm-proof-stats">
          <div className="mm-ps-item"><div className="mm-ps-num">500+</div><div className="mm-ps-lbl">Active mentors</div></div>
          <div className="mm-ps-item"><div className="mm-ps-num">IIT/AIIMS/NIT</div><div className="mm-ps-lbl">Verified colleges</div></div>
          <div className="mm-ps-item"><div className="mm-ps-num">4.9&#9733;</div><div className="mm-ps-lbl">Average mentor rating</div></div>
          <div className="mm-ps-item"><div className="mm-ps-num">2/week</div><div className="mm-ps-lbl">Sessions on all paid plans</div></div>
        </div>
        <div className="mm-review-grid">
          <div className="mm-rev-card">
            <div className="mm-rev-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
            <div className="mm-rev-text">&ldquo;My mock score jumped from 320 to 520 in 6 weeks. The daily check-in kept me accountable every single day. My mentor knew exactly where I was losing marks.&rdquo;</div>
            <div className="mm-rev-name">Simrai &middot; JEE aspirant &middot; Silver plan</div>
          </div>
          <div className="mm-rev-card">
            <div className="mm-rev-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
            <div className="mm-rev-text">&ldquo;I started with the &#8377;249 Basic session just to test. Got so much clarity in one call that I upgraded to Platinum the same day. Best &#8377;249 I ever spent.&rdquo;</div>
            <div className="mm-rev-name">Ananya S. &middot; NEET aspirant &middot; Platinum plan</div>
          </div>
          <div className="mm-rev-card">
            <div className="mm-rev-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
            <div className="mm-rev-text">&ldquo;As a parent I was sceptical of online mentoring. After two months on Silver, my daughter's confidence is completely different. She has a plan now &mdash; not just panic.&rdquo;</div>
            <div className="mm-rev-name">Parent of NEET aspirant &middot; Silver plan</div>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className="mm-faq">
        <div className="mm-sec-head">
          <h2>Common questions</h2>
          <p>Everything you need to know before buying</p>
        </div>
        <div className="mm-faq-grid">
          <div className="mm-faq-card">
            <div className="mm-fq">What exactly does the &#8377;249 Basic session cover?</div>
            <div className="mm-fa">One 45&ndash;60 minute session where you choose one topic from five options &mdash; mock test analysis, book selection, revision strategy, subject strategy, or marks improvement. Surface-level guidance to get you unstuck quickly. No ongoing support.</div>
          </div>
          <div className="mm-faq-card">
            <div className="mm-fq">What is daily check-in and check-out?</div>
            <div className="mm-fa">On paid plans, your assigned mentor checks what you plan to study each morning (check-in) and reviews what you actually completed each evening (check-out). This daily accountability is what separates MentoMEET from every other platform.</div>
          </div>
          <div className="mm-faq-card">
            <div className="mm-fq">Are Gold, Platinum and Diamond different from Silver?</div>
            <div className="mm-fa">No &mdash; they have identical features. The only difference is duration. Gold = 3 months, Platinum = 6 months, Diamond = 12 months. The longer you commit, the less you pay per month.</div>
          </div>
          <div className="mm-faq-card">
            <div className="mm-fq">Can I message any mentor on the free plan?</div>
            <div className="mm-fa">On free you can message 1 mentor only. Paid plans give you unlimited chat with your allotted mentor plus daily check-in support.</div>
          </div>
          <div className="mm-faq-card">
            <div className="mm-fq">What is an error book?</div>
            <div className="mm-fa">Your mentor tracks every mistake you make across mock tests in a personal error book. Over time this becomes your most targeted revision tool. Only available on paid plans.</div>
          </div>
          <div className="mm-faq-card">
            <div className="mm-fq">Is the 7-day money-back guarantee real?</div>
            <div className="mm-fa">Yes &mdash; completely real. If you are not satisfied within 7 days of starting any paid plan, we refund 100% with no questions asked.</div>
          </div>
        </div>
      </div>

      {/* BOTTOM CTA */}
      <div className="mm-bottom-cta">
        <h2>Not sure where to start?</h2>
        <p>Try one session for &#8377;249. No subscription. No pressure. See the difference in 60 minutes.</p>
        <div className="mm-bc-btns">
          <Link to="/scheduleMeeting" className="mm-bc-btn mm-bc-p">Book a &#8377;249 session &rarr;</Link>
          <Link to="/mentors" className="mm-bc-btn mm-bc-g" style={{ border: "2px solid #6B21B6" }}>Browse mentors</Link>
        </div>
        <div className="mm-bc-trust">
          <div className="mm-bct-item">7-day money-back guarantee</div>
          <div className="mm-bct-item">No credit card for free plan</div>
          <div className="mm-bct-item">Cancel anytime</div>
          <div className="mm-bct-item">Secure payments via Razorpay</div>
        </div>
      </div>
    </div>
  );
}
